import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children", "Content"];
import styled from 'foundations-theming/utils';
import { AccordionTransition, AccordionTransitionWrapper } from '../AccordionTransition/AccordionTransition';
import { Controllable } from '../Controllable';
import { EDITABLE_CONTROLS_TRANSITION_TIMING } from '../../../constants/times';
import { toPx } from '../../../utils/toPx';
import { jsx as _jsx } from "react/jsx-runtime";
const EDITABLE_CONTROLS_TRANSITION_TIMEOUT = parseInt(EDITABLE_CONTROLS_TRANSITION_TIMING, 10);
const DRAWER_PADDING_Y = 8;
const SlideoutTransitionWrapper = styled(AccordionTransitionWrapper)(({
  duration,
  measuredHeight,
  transitionActive,
  opening,
  transitioning,
  open
}) => {
  const opacityDuration = opening ? duration * 0.7 : duration * 0.3;
  const opacityDelay = opening ? duration - opacityDuration : 0;
  return {
    height: 'auto',
    transition: !transitionActive || measuredHeight === null ? 'none' : `opacity ${opacityDuration}ms ease-out ${opacityDelay}ms, transform ${duration}ms`,
    transform: transitioning && measuredHeight ? open ? `translateY(0)` : `translateY(${toPx(-1 * (measuredHeight - DRAWER_PADDING_Y))})` : undefined
  };
});
const DrawerContent = styled.div.withConfig({
  displayName: "SlideoutDrawer__DrawerContent",
  componentId: "etkh94-0"
})(({
  theme
}) => {
  return {
    paddingBlock: theme.space['300']
  };
});
export const SlideoutDrawerComponent = _ref => {
  let {
      children,
      Content = DrawerContent
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsx(AccordionTransition, Object.assign({}, rest, {
    duration: EDITABLE_CONTROLS_TRANSITION_TIMEOUT,
    Wrapper: SlideoutTransitionWrapper,
    children: /*#__PURE__*/_jsx(Content, {
      children: children
    })
  }));
};

// Consider removing & updating if we ever adapt the Controllable component API to accept defaults
// eslint-disable-next-line hubspot-dev/no-default-props-assignment
SlideoutDrawerComponent.defaultProps = {
  open: false
};
export const SlideoutDrawer = Controllable(SlideoutDrawerComponent, ['open']);